// components/FilePreviewCard.js
import React from "react";
import styled from "styled-components";
import {
  DeleteIcon,
  PdfIcon,
  ResendIcon,
  Trash,
} from "../../../styled/AllImages";
import { Box, SpanStyled } from "../../../styled/Elements";
import { useTranslation } from "react-i18next";

const Card = styled.div`
  position: relative;
  width: 110px;
  height: 110px;
  border-radius: 12px;
  background-color: var(--bgPrimary);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-right: 10px;
  .buttons-wrapper {
    margin-right: ${({ lang }) => (lang === "en" ? "15px" : "unset")};
    margin-left: ${({ lang }) => (lang === "ar" ? "15px" : "unset")};
  }
  .content-wrapper {
    background-color: var(--white);
    width: 100%;
    height: 70%;
    margin-right: 15px;
    margin-left: 17px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const Thumbnail = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
`;

const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RemoveBtn = styled.button`
  /* position: absolute;
  top: 4px;
  right: 4px; */
  background: white;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

const UrlPreviewCard = ({ file, onRemove }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const getPreviewContent = () => {
    let url,
      name,
      isPdf = false;

    if (file instanceof File) {
      name = file.name;
      isPdf =
        file.type === "application/pdf" || name.toLowerCase().endsWith(".pdf");
      url = isPdf ? PdfIcon : URL.createObjectURL(file);
    } else if (typeof file === "string") {
      name = file.split("/").pop();
      isPdf = name.toLowerCase().endsWith(".pdf");
      url = isPdf ? PdfIcon : file;
    } else {
      name = file?.name || "file";
      isPdf = name.toLowerCase().endsWith(".pdf");
      url = isPdf ? PdfIcon : file?.url || "";
    }

    return (
      <Box className="d-flex align-items-center gap-3">
        <Box
          style={{
            width: "50px",
            height: "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Thumbnail src={url} alt={name} />
        </Box>
        <Box className="d-flex flex-column">
          <SpanStyled color="var(--text)" weight="bold" size="14px">
            {name}
          </SpanStyled>
          <SpanStyled color="var(--text2)" size="14px">
            {t("max_file_size")}: 2 MB
          </SpanStyled>
        </Box>
      </Box>
    );
  };

  return (
    <Card lang={language}>
      <Box className="content-wrapper">{getPreviewContent()}</Box>
      <Box className="d-flex gap-2 flex-column buttons-wrapper">
        <RemoveBtn type="button" onClick={onRemove}>
          <DeleteIcon size={14} />
        </RemoveBtn>
        <RemoveBtn type="button" onClick={onRemove}>
          <ResendIcon size={14} />
        </RemoveBtn>
      </Box>
    </Card>
  );
};

export default UrlPreviewCard;
